// ── Custom cursor ──────────────────────────────────────────────
const cursor = document.getElementById('cursor');
const ring   = document.getElementById('cursor-ring');
let mx=0,my=0,rx=0,ry=0;
document.addEventListener('mousemove',e=>{
  mx=e.clientX; my=e.clientY;
  cursor.style.left=mx+'px'; cursor.style.top=my+'px';
});
(function animRing(){
  rx+=(mx-rx)*0.12; ry+=(my-ry)*0.12;
  ring.style.left=rx+'px'; ring.style.top=ry+'px';
  requestAnimationFrame(animRing);
})();
document.querySelectorAll('a,button,.p-card,[class*="card"]').forEach(el=>{
  el.addEventListener('mouseenter',()=>{ cursor.style.width='20px'; cursor.style.height='20px'; ring.style.width='60px'; ring.style.height='60px'; });
  el.addEventListener('mouseleave',()=>{ cursor.style.width='10px'; cursor.style.height='10px'; ring.style.width='36px'; ring.style.height='36px'; });
});

// ── 3D Section scroll-in ───────────────────────────────────────
const animEls = document.querySelectorAll('.anim-left,.anim-right,.anim-up,.anim-scale');
if ('IntersectionObserver' in window) {
  const io3d = new IntersectionObserver(entries=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('is-visible'); io3d.unobserve(e.target); } });
  },{threshold:0.07, rootMargin:'0px 0px -30px 0px'});
  animEls.forEach(el=>io3d.observe(el));
} else {
  animEls.forEach(el=>el.classList.add('is-visible'));
}

// ── Legacy .reveal cards ───────────────────────────────────────
const reveals = document.querySelectorAll('.reveal');
const ioRev = new IntersectionObserver(entries=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('visible'); ioRev.unobserve(e.target); } });
},{threshold:0.08});
reveals.forEach(el=>ioRev.observe(el));

// ── 3D tilt on product cards ───────────────────────────────────
document.querySelectorAll('.p-card:not(.coming-soon)').forEach(card=>{
  card.addEventListener('mousemove',e=>{
    const r=card.getBoundingClientRect();
    const x=((e.clientX-r.left)/r.width-0.5)*14;
    const y=((e.clientY-r.top)/r.height-0.5)*-14;
    card.style.transform=`translateY(-12px) rotateX(${y}deg) rotateY(${x}deg) scale(1.01)`;
  });
  card.addEventListener('mouseleave',()=>{ card.style.transform=''; });
});

// ── Thumbnail switcher — called via inline onclick ─────────────
window.lumoraSwitchImage = function(btn, src) {
  document.querySelectorAll('.pdp-thumb').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var mainImg = document.getElementById('pdp-main-img');
  if (!mainImg || !src) return;
  mainImg.style.transition = 'opacity 0.2s ease';
  mainImg.style.opacity = '0';
  setTimeout(function() {
    mainImg.src = src;
    mainImg.style.opacity = '1';
  }, 180);
};

// ── Variant pills (PDP) ────────────────────────────────────────
document.querySelectorAll('.pdp-variant-pill').forEach(pill=>{
  pill.addEventListener('click',()=>{
    document.querySelectorAll('.pdp-variant-pill').forEach(p=>p.classList.remove('selected'));
    pill.classList.add('selected');
    const vid=document.getElementById('pdp-variant-id');
    const pr=document.querySelector('.pdp-price');
    if(vid) vid.value=pill.dataset.variantId;
    if(pr && pill.dataset.price) pr.textContent=pill.dataset.price;
  });
});

// ── Qty buttons (PDP) ─────────────────────────────────────────
const qtyInput=document.getElementById('pdp-qty-input');
const qtyMinus=document.getElementById('qty-minus');
const qtyPlus=document.getElementById('qty-plus');
if(qtyInput && qtyMinus) qtyMinus.addEventListener('click',()=>{ if(parseInt(qtyInput.value)>1) qtyInput.value=parseInt(qtyInput.value)-1; });
if(qtyInput && qtyPlus)  qtyPlus.addEventListener('click',()=>{ qtyInput.value=parseInt(qtyInput.value)+1; });

// ── Scroll Reveal: 3D left/right + word stagger ────────────────
(function(){
  if(!('IntersectionObserver' in window)) return;

  // Delay to ensure initial paint happens before we hide elements
  setTimeout(function(){

    /* ── 1. Word-by-word heading reveal ── */
    function revealWords(el){
      if(el.dataset.ws) return;
      el.dataset.ws='1';
      var words=el.querySelectorAll('.sr-word');
      words.forEach(function(w,i){
        setTimeout(function(){ w.style.opacity='1'; w.style.transform='none'; },i*90);
      });
    }

    // Split plain-text nodes only (safe - skips em/span children)
    function splitEl(el){
      if(el.dataset.ws) return;
      el.dataset.ws='1';
      var nodes=Array.from(el.childNodes);
      el.innerHTML='';
      nodes.forEach(function(n){
        if(n.nodeType===3){
          n.textContent.split(/(\s+)/).forEach(function(p){
            if(/^\s+$/.test(p)){ el.appendChild(document.createTextNode(p)); return; }
            if(!p) return;
            var s=document.createElement('span');
            s.className='sr-word';
            s.style.cssText='display:inline-block;opacity:0;transform:translateX(-20px);transition:opacity 0.5s cubic-bezier(0.22,1,0.36,1),transform 0.5s cubic-bezier(0.22,1,0.36,1)';
            s.textContent=p;
            el.appendChild(s);
          });
        } else {
          el.appendChild(n.cloneNode(true));
        }
      });
    }

    var headings=document.querySelectorAll('.s-title,.col-title,.cart-title,.bundle-title,.track-modal-title');
    headings.forEach(splitEl);

    var ioH=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        revealWords(e.target);
        ioH.unobserve(e.target);
      });
    },{threshold:0.05,rootMargin:'0px 0px -10px 0px'});
    headings.forEach(function(el){ ioH.observe(el); });

    /* ── 2. Cards/rows: alternate 3D left-right with perspective ── */
    var cards=document.querySelectorAll('.p-card,.feat4-card,.why-card,.review-card,.home-rev-card,.ing-line,.ritual-step,.howto-step,.about-badge,.trust-item,.pdp-bf-list li,.stat-block');
    cards.forEach(function(el,i){
      var even=i%2===0;
      var t=even?'perspective(900px) rotateY(10deg) translateX(-55px) scale(0.95)':'perspective(900px) rotateY(-10deg) translateX(55px) scale(0.95)';
      el.style.cssText+='opacity:0;transform:'+t+';transition:opacity 0.75s cubic-bezier(0.22,1,0.36,1),transform 0.75s cubic-bezier(0.22,1,0.36,1);transition-delay:'+(i%4*0.08)+'s';
    });
    var ioC=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.style.opacity='1';
        e.target.style.transform='none';
        ioC.unobserve(e.target);
      });
    },{threshold:0.07,rootMargin:'0px 0px -20px 0px'});
    cards.forEach(function(el){ ioC.observe(el); });

    /* ── 3. Text blocks: fade up ── */
    var texts=document.querySelectorAll('.s-body,.hero-subtext,.p-desc,.pdp-desc-short,.col-desc,.bundle-sub,.s-eyebrow');
    texts.forEach(function(el,i){
      el.style.cssText+='opacity:0;transform:translateY(18px);transition:opacity 0.6s ease,transform 0.6s ease;transition-delay:'+(i%3*0.07)+'s';
    });
    var ioT=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.style.opacity='1';
        e.target.style.transform='none';
        ioT.unobserve(e.target);
      });
    },{threshold:0.1,rootMargin:'0px 0px -10px 0px'});
    texts.forEach(function(el){ ioT.observe(el); });

    /* ── Fallback: reveal everything after 4s in case observer fails ── */
    setTimeout(function(){
      document.querySelectorAll('.sr-word').forEach(function(w){ w.style.opacity='1'; w.style.transform='none'; });
    },4000);

  }, 150);
})();
